/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AiCoachControllerToggleAutomaticResponseBodyRequest {
  chatRoomID: string;
  enabled: boolean;
}

export interface AiCoachControllerToggleAutomaticResponseResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export interface AiCoachControllerDelayAutomaticResponseBodyRequest {
  chatRoomID: string;
}

export interface AiCoachControllerDelayAutomaticResponseResponse {
  code: number;
  data: {
    delayedTime?: string;
  };
  message: string;
}

export interface AiCoachControllerTriggerAutomaticResponseBodyRequest {
  chatRoomID: string;
}

export interface AiCoachControllerTriggerAutomaticResponseResponse {
  code: number;
  data: Record<string, any>;
  message: string;
}

export type AiCoachControllerToggleAutomaticResponseData = AiCoachControllerToggleAutomaticResponseResponse;

export type AiCoachControllerDelayAutomaticResponseData = AiCoachControllerDelayAutomaticResponseResponse;

export interface AiCoachControllerFindAutomaticResponseParams {
  chatRoomID: string;
}

export type AiCoachControllerFindAutomaticResponseData = any;

export type AiCoachControllerTriggerAutomaticResponseData = AiCoachControllerTriggerAutomaticResponseResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 자동 응대 사용 여부 전환
     *
     * @tags V3-Ai-Coach
     * @name AiCoachControllerToggleAutomaticResponse
     * @summary 자동 응대 사용 여부 전환
     * @request POST:/v3/api/ai-coach/automatic-response/toggle
     * @secure
     * @response `200` `AiCoachControllerToggleAutomaticResponseData` success
     */
    aiCoachControllerToggleAutomaticResponse: (
      data: AiCoachControllerToggleAutomaticResponseBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AiCoachControllerToggleAutomaticResponseData, any>({
        path: `/v3/api/ai-coach/automatic-response/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 자동 응대 발송을 미룹니다
     *
     * @tags V3-Ai-Coach
     * @name AiCoachControllerDelayAutomaticResponse
     * @summary 자동 응대 발송 미루기
     * @request POST:/v3/api/ai-coach/automatic-response/delay
     * @secure
     * @response `200` `AiCoachControllerDelayAutomaticResponseData` success
     */
    aiCoachControllerDelayAutomaticResponse: (
      data: AiCoachControllerDelayAutomaticResponseBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AiCoachControllerDelayAutomaticResponseData, any>({
        path: `/v3/api/ai-coach/automatic-response/delay`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description QA용 자동 응대 조회. 현재 예약되어있는 자동응대를 조회함
     *
     * @tags V3-Ai-Coach-QA-Only
     * @name AiCoachControllerFindAutomaticResponse
     * @summary 자동 응대 조회
     * @request GET:/v3/api/ai-coach/automatic-response
     * @secure
     * @response `200` `AiCoachControllerFindAutomaticResponseData` 成功响应
     */
    aiCoachControllerFindAutomaticResponse: (
      query: AiCoachControllerFindAutomaticResponseParams,
      params: RequestParams = {},
    ) =>
      this.request<AiCoachControllerFindAutomaticResponseData, any>({
        path: `/v3/api/ai-coach/automatic-response`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description QA용 자동 응대 발송 트리거
     *
     * @tags V3-Ai-Coach-QA-Only
     * @name AiCoachControllerTriggerAutomaticResponse
     * @summary 자동 응대 발송 트리거
     * @request POST:/v3/api/ai-coach/automatic-response/trigger
     * @secure
     * @response `200` `AiCoachControllerTriggerAutomaticResponseData` success
     */
    aiCoachControllerTriggerAutomaticResponse: (
      data: AiCoachControllerTriggerAutomaticResponseBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AiCoachControllerTriggerAutomaticResponseData, any>({
        path: `/v3/api/ai-coach/automatic-response/trigger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
